<!--订单列表-->
<template>
    <div>
        <top-bar
            :height="'48vh'"
            :loading="loading"
            @refresh="refresh"
            title="订单"
            :isShowRefresh="true"
			:isExport="true"
            @search="topSearch"
			@exportOrder="exportOrder"
        />
        <v-container fluid class="mt-n5">
            <v-row>
                <v-col cols="12" md="12">
                    <v-card flat outlined :color="theme.pageBgColor"  class="center">
                        <order-search
                            ref="orderSearch"
                            @search="search"
                            :isClickData="isClickData"
                        />
                    </v-card>
                </v-col>
                <v-col cols="12" md="12" class="mt-n5">
                    <el-tabs v-model="activeName" @tab-click="handleClick" class="pa-3">
                        <el-tab-pane v-for="(item, index) in title" :key="index" :name="item.name">
                            <span
                                slot="label"
                                :style="{
                                    color:
                                        activeName == item.name ? '#4dabf7' : theme.pageFontColor,
                                }"
                            >
                                {{ item.label }}
                            </span>
                            <v-card flat outlined :color="theme.pageBgColor">
                                <order-table
                                    ref="orderTable"
                                    @loading="isLoading"
                                    :searchData="searchData"
                                    @clickTel="clickTel"
                                    @clickStation="clickStation"
                                    @clickConn="clickConn"
                                />
                            </v-card>
                        </el-tab-pane>
                    </el-tabs>
                </v-col>
                <v-col cols="12" md="12" v-if="false">
                    <el-button type="primary" @click="get()">获取所有枪充电量数据</el-button>
                    <!-- <el-button type="primary" @click="getOrderQuerySum()">获取所有枪当天电量</el-button> -->
                    <download-excel
                        class = "export-excel-wrapper"
                        :data = "json_data"
                        :fields = "json_fields"
                        title="当前站点的所有枪充电量数据"
                        :name = "json_name + '所有枪充电量数据.xls'">
                        <el-button type="primary">导出所有枪当前时间电量为EXCEL</el-button>
                    </download-excel>
                </v-col>
            </v-row>
        </v-container>
    </div>
</template>
<script>
import util from "@/util";
import store from "@/store";
import Public from "@/public";
import TopBar from "@/components/TopBar";
import OrderSearch from "@/components/OrderSearch";
import OrderTable from "@/components/Table/OrderTable";
import { mapState } from "vuex";
export default {
    name: "OrderList",
    data() {
        return {
            loading: false,
            activeName: "first",
            title: [
                {
                    label: "所有订单",
                    name: "first",
                },
            ],
            searchData: {}, //搜索条件
            isClickData: true, //是否点击了数据表中的数据
            
            allGunInfo: [],
            json_name: null,
            json_fields: {
                "站点ID": "station_id",
                "站点名称": "station_name",
                "桩ID": "equipment_id",
                "枪ID": "connector_id", 
                "枪名称": "name",
                "订单数": "order_count",
                "电费": "elec_money",
                "服务费": "sevice_money",
                "电量": "total_power",
            },
            json_data:[],    //导出表格数据
            json_meta: [
              [
                {
                  " key ": " charset ",
                  " value ": " utf- 8 "
                }
              ]
            ],
        };
    },
    components: {
        OrderSearch,
        OrderTable,
        TopBar,
    },
    async mounted() {
        // this.refresh();
    },
    computed: { 
        ...mapState(["theme", "orderInfos", "contactInfo","siteList","connectorInfo","orderQuerySum"]),
    },
    methods: {
		exportOrder() {
			this.$refs.orderSearch.exportOrder();
		},
        async topSearch(reg) {
            util.ShowTip("请使用下面更详细的搜索项", 3);
            return;
            this.loading = true;
            let params = {
                postData: {
                    from: 0,
                    limit: 100000,
                },
                callback: () => {
                    this.loading = false;
                },
            }
            await store.dispatch("getOrder", params);
            console.log(this.orderInfos)
            let dataArr = [];
            for (let i = 0; i < this.orderInfos.length; i++) {
                if (
                    reg.test(this.orderInfos[i].cec_id) ||
                    reg.test(this.orderInfos[i].connector_id) ||
                    reg.test(this.orderInfos[i].mobile) ||
                    reg.test(this.orderInfos[i].no)
                ) {
                    dataArr.push(this.orderInfos[i]);
                }
            }
            console.log(dataArr)
            this.$refs.orderTable[0].order = dataArr;
            util.ShowTip("查询到" + dataArr.length + "条数据", 1);
        },
        //获取所有充电枪数据
        async get() {
            console.log(this.$refs.orderSearch.form.time)
            if(this.$refs.orderSearch.form.time == null) {
                util.ShowTip("请选择时间", 2);
                return
            }
            const loading = this.$loading({
                lock: true,
                text: '正在获取所有枪数据...',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });
            let site = this.JsonData(this.siteList)
            console.log(site)
            let allsite = []
            for(let i = 0;i<site.length;i++) {
                for(let j = 0;j<site[i].children.length;j++) {
                    allsite.push({
                        station_id: site[i].children[j].id,
                        station_name: site[i].children[j].value
                    })
                }
            }
            console.log(allsite)
            let promiseArr = [];
            for (let i = 0; i < allsite.length; i++) {
                let postData = {
                    station_id: allsite[i].station_id,
                };
                await store.dispatch("getConnector", postData);
                let promise = new Promise((resolve, reject) => {
                    let data = this.JsonData(this.connectorInfo)
                    for(let j = 0;j<data.length;j++) {
                        data[j].station_id = allsite[i].station_id
                    }
                    resolve(data);
                });
                promiseArr.push(promise);
            }
            Promise.allSettled(promiseArr)
                .then(result => {
                    console.log(result)
                    let info = []
                    for(let i = 0;i<result.length;i++) {
                        for(let j =0;j<result[i].value.length;j++) {
                            info.push(result[i].value[j])
                        }
                    }
                    // for(let a = 0;a<info.length;a++) {
                    //     info[a].connector_id = info[a].connector_id + '&nbsp;'
                    //     info[a].name = info[a].name + '&nbsp;'
                    // }
                    for(let i = 0;i<allsite.length;i++) {
                        for(let j = 0;j<info.length;j++) {
                            if(allsite[i].station_id == info[j].station_id) {
                                info[j].station_name = allsite[i].station_name
                            }
                        }
                    }
                    console.log(info)
                    this.allGunInfo = info;
                    // this.json_data = info;
                    loading.close();
                    // util.ShowTip("总共获取到"+info.length+"条数据", 1);
                    this.getOrderQuerySum()
                })
                .catch(error => {
                    loading.close();
                    util.ShowTip(error, 2);
                });
        },
        async getOrderQuerySum() {
            let start_time = this.$refs.orderSearch.form.time[0]
            let end_time = this.$refs.orderSearch.form.time[1] + 24 * 60 * 60 * 1000
            console.log(Public.longDataToStr(start_time));
            console.log(Public.longDataToStr(end_time));
            this.json_name = Public.longDataToStr2(start_time) + '-'+ Public.longDataToStr2(end_time);
            const loading = this.$loading({
                lock: true,
                text: '正在获取所有枪'+Public.longDataToStr(start_time) +'-'+Public.longDataToStr(end_time)+'充电量数据...',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });
            console.log(this.allGunInfo)
            // let end_time = new Date().getTime();
            // let start_time = new Date(new Date().toLocaleDateString()).getTime();
            let promiseArr = [];
            for(let i = 0;i<this.allGunInfo.length;i++) {
                let params = {
                    postData: {
                        connector_id: this.allGunInfo[i].connector_id,
                        end_time: parseInt(end_time / 1000),
                        start_time: parseInt(start_time / 1000),
                    },
                };
                await store.dispatch("getOrderQuerySum", params);
                let promise = new Promise((resolve, reject) => {
                    let data = this.JsonData(this.orderQuerySum)
                    data.station_id = this.allGunInfo[i].station_id
                    data.station_name = this.allGunInfo[i].station_name
                    data.equipment_id = this.allGunInfo[i].equipment_id
                    data.connector_id = this.allGunInfo[i].connector_id  + '&nbsp;'
                    data.name = this.allGunInfo[i].name  + '&nbsp;'
                    resolve(data);
                });
                promiseArr.push(promise);
            }
            Promise.allSettled(promiseArr)
                .then(result => {
                    console.log(result)
                    let info = []
                    for(let i = 0;i<result.length;i++) {
                        info.push(result[i].value)
                    }
                    console.log(info)
                    this.json_data = info;
                    loading.close();
                })
                .catch(error => {
                    loading.close();
                    util.ShowTip(error, 2);
                });
        },
        refresh() {
            this.$refs.orderSearch.search();
        },
        /*搜索*/
        search(postData) {
            this.searchData = postData;
        },
        /*点击数据表中的电话号码*/
        clickTel(mobile) {
            this.isClickData = !this.isClickData;
            this.$refs.orderSearch.form.mobile = Number(mobile);
        },
        /*点击数据表中的站点*/
        clickStation(station) {
            this.isClickData = !this.isClickData;
            this.$refs.orderSearch.form.selectSiteId = Number(station);
        },
        /*点击数据表中的充电枪*/
        clickConn(ConnId) {
            this.isClickData = !this.isClickData;
            this.$refs.orderSearch.form.connector_id = ConnId;
        },
        isLoading(data) {
            this.loading = data;
        },
        handleClick(tab, event) {
            // console.log(tab);
            let index = tab.index;
            if (index == 0) {
                this.refresh();
            }
            if (index == 1) {
            }
            if (index == 2) {
            }
        },
        JsonData(data) {
            return JSON.parse(JSON.stringify(data));
        },
    },
    beforeRouteLeave(to, from, next) {
        from.meta.keepAlive = true;
        next();
    },
    beforeRouteEnter(to, from, next) {
        next(vm => {
            vm.refresh();
        });
    },
};
</script>
<style scoped>
.center {
    display: flex;
    justify-content: center;
    align-items: center;
}
</style>
